<template>
  <div class="home">
    <div
      class="background"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/mayologobg2.png') + ')'
      }"
    ></div>
    <div class="logo">
      <img src="@/assets/img/mayologo.png" />
    </div>
    <div class="menu">
      <div class="left-bg">
        <div class="left">
          <h1>The Division of Engineering</h1>
          <div class="line"></div>
          <div class="menu-item">
            <p
              id="overview"
              @click="toggleActive"
              :class="{ active: current === 'overview' }"
            >
              Who We Are
            </p>
            <img src="@/assets/img/go.png" />
          </div>

          <div class="menu-item">
            <p
              id="manufacturing"
              @click="toggleActive"
              :class="{ active: current === 'manufacturing' }"
            >
              What We Do
            </p>
            <img src="@/assets/img/go.png" />
          </div>

          <div class="menu-item">
            <p id="equipment" @click="popup = 7">
              Our History
            </p>
            <img src="@/assets/img/go.png" />
          </div>
        </div>
      </div>

      <div class="right">
        <transition>
          <div class="overview" v-if="current === 'overview'">
            <h3>Who We Are</h3>
            <p>
              The Division of Engineering is a group of multi-disciplinary
              engineers and technicians with a passion for solving today’s
              challenges in medical innovation.
            </p>
            <p>
              We partner directly with Mayo Clinic clinicians and researchers to
              transform their ideas into practice.
            </p>
          </div>
        </transition>

        <transition>
          <div class="manufacturing" v-if="current === 'manufacturing'">
            <h3>What We Do</h3>
            <p>
              We provide engineering consultation, design, and development
              services to Mayo Clinic staff needing systems, instruments, or
              devices that are not commercially available.
            </p>
            <li>
              Integrated Electrical, Mechanical, and Software Design/Development
            </li>
            <li>Machine Shop Fabrication Services</li>
            <li>Metal and Polymer 3D Printing</li>
            <li>Scientific Glass Blowing</li>
            <li>Microfabrication</li>
            <li>Project Management</li>
            <li>Medical Device Safety Analysis</li>
          </div>
        </transition>

        <transition>
          <div v-if="popup == 7" class="popup">
            <div class="offclick" @click="popup = false"></div>
            <div class="info">
              <h3>Our History</h3>
              <ol>
                <li>
                  1915
                  <span class="details">
                    Mayo Clinic Instrument Shop
                  </span>
                </li>
                <li>
                  1948
                  <span class="details">
                    Instrument Shop reformed as the Division of Engineering
                  </span>
                </li>
                <li>
                  Today
                  <span class="details">
                    A comprehensive medical device development organization
                  </span>
                </li>
                <li>
                  Tomorrow
                  <span class="details">
                    Description
                  </span>
                </li>
              </ol>
            </div>
          </div>
          <!-- <h3>Our State of the Art Equipment</h3> -->
        </transition>

        <!-- <transition>
          <div class="process" v-if="current === 'process'">
            <h3>Our Process</h3>
            <p>(Leave for now)</p>
          </div>
        </transition>

        <transition>
          <div class="link1" v-if="current === 'link1'">
            <h3>What is Additive Manufacturing?</h3>
            <p>
              Additive Manufacturing, or 3D Printing, is a process of
              fabricating three dimensional objects from a digital file. The
              creation process is achieved through laying down successive layers
              of material until the object is created. Each layer can be seen as
              an extremely thin horizontal cross section of the object Additive
              Manufacturing is the opposite of subtractive manufacturing; which
              is creation through removing material.
            </p>
          </div>
        </transition>

        <transition>
          <div class="link2" v-if="current === 'link2'">
            <h3>Common Types of 3D Printing</h3>
            <div class="sub-menu">
              <div class="printers">
                <div class="menu-item">
                  <p @click="popup = 1">
                    Fused deposition modeling (FDM)
                  </p>
                  <img src="@/assets/img/go.png" />
                </div>
                <div class="menu-item">
                  <p @click="popup = 2">
                    Stereolithography (SLA)
                  </p>
                  <img src="@/assets/img/go.png" />
                </div>
                <div class="menu-item">
                  <p @click="popup = 3">
                    Selective Laser Sintering (SLS)
                  </p>
                  <img src="@/assets/img/go.png" />
                </div>
              </div>

              <div v-if="popup == 1" class="popup">
                <div class="offclick" @click="popup = false"></div>
                <div class="room">
                  <div class="info">
                    <h3>Fused deposition modeling (FDM)</h3>
                    <div class="line2"></div>
                    <p>
                      Fused Deposition Modeling is one of the most popular
                      additive manufacturing technologies used today. Printers
                      that use this method create objects by extruding material
                      in very thin layers. Each layer can be seen as a cross
                      section of the object being printer. Click the video below
                      to learn more!
                    </p>
                    <div class="videos">
                      <div class="video-modal">
                        <h3>Overview:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/rkUILe3zv98"
                        >
                        </iframe>
                      </div>
                      <div class="video-modal">
                        <h3>Time-lapse:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/9cLFAI1_fmU"
                        >
                        </iframe>
                      </div>
                    </div>
                    <p>
                      Which of our printers use this technology? – Link to
                      State-of-the-Art Equipment Page Stratasys Fortus 400mc
                      Stratasys F370 Markforged Mark Two
                    </p>
                  </div>
                </div>
              </div>

              <div v-if="popup == 2" class="popup">
                <div class="offclick" @click="popup = false"></div>
                <div class="room">
                  <div class="info">
                    <h3>Fused deposition modeling (FDM)</h3>
                    <div class="line2"></div>
                    <p>
                      Stereolithography technology creates objects not by
                      material extrusion, but by vat polymerization. Objects are
                      built using a light source, typically a laser or
                      projector, to cure liquid resin into hard plastic. Click
                      the video below to learn more!
                    </p>
                    <div class="videos">
                      <div class="video-modal">
                        <h3>Overview:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/8a2xNaAkvLo"
                        >
                        </iframe>
                      </div>
                      <div class="video-modal">
                        <h3>Time-lapse:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/klW0nuefofY"
                        >
                        </iframe>
                      </div>
                    </div>
                    <p>
                      Which of our printers use this technology? – Link to
                      State-of-the-Art Equipment Page Formlabs Form 3
                    </p>
                  </div>
                </div>
              </div>

              <div v-if="popup == 3" class="popup">
                <div class="offclick" @click="popup = false"></div>
                <div class="room">
                  <div class="info">
                    <h3>Selective Laser Sintering (SLS)</h3>
                    <div class="line2"></div>
                    <p>
                      Selective Laser Sintering is another a method of 3D
                      printing in the vat polymerization. Much like SLA, SLS
                      uses a laser to fuse material and build objects. The most
                      notable difference between the two is that SLS uses
                      powdered material instead of liquid resin.
                    </p>
                    <div class="videos">
                      <div class="video-modal">
                        <h3>Overview:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/9E5MfBAV"
                        >
                        </iframe>
                      </div>
                      <div class="video-modal">
                        <h3>Time-lapse:</h3>
                        <iframe
                          width="620"
                          height="345"
                          src="https://www.youtube.com/embed/9cLFAI1_fmU"
                        >
                        </iframe>
                      </div>
                    </div>
                    <p>
                      Which of our printers use this technology? – Link to
                      State-of-the-Art Equipment Page EOS M290 Titanium Printer
                      HP Jet Fusion 580 Color Printer (Multi Jet Fusion)
                    </p>
                  </div>
                </div>
              </div>
              <div class="printer-one">
                <h3>Fused deposition modeling (FDM)</h3>
              </div>
            </div>
          </div>
        </transition> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: "overview",
      popup: null,
      popup: false
    };
  },
  methods: {
    toggleActive(event) {
      this.current = event.target.id;
    }
  }
};
</script>

<style scoped>
h1 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 83px;
  position: relative;
  padding-top: 0px;
  width: 500px;
  text-align: center;
  font-weight: lighter;
  letter-spacing: 7px;
  text-align: left;
  margin: 0;
}
.video-modal h3 {
  font-size: 30px;
  margin-bottom: 10px;
  font-family: AzoSans;
  letter-spacing: auto;
}

h3 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 50px;
  position: relative;
  padding-top: 0px;
  /* width: 500px; */
  text-align: center;
  font-weight: lighter;
  letter-spacing: 7px;
  text-align: left;
  margin: 30px 0;
}

.left {
  /* padding-left: 157px;
    flex: none;
    padding-top: 301px;
    width: 500px; */

  /* css for demo */
  /* padding-right: 120px; */
  padding-top: 235px;
  position: fixed;
  left: 200px;
}

.right {
  padding-top: 235px;
  padding-left: 600px;
  position: relative !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  width: 44%;
  /* height: 100vh !important; */
  justify-content: flex-start !important;
  overflow: hidden !important;
  overflow-x: auto !important;
}

.btn {
  background-color: rgba(255, 255, 255, 0.1);
  z-index: 11;
  /* width: 100px;
  height: 50px;  */
}

.logo img {
  position: fixed;
  z-index: 11;
}

.menu {
  padding: 0;
  overflow: hidden !important;
}

.left-bg {
  width: 43%;
}

.card {
  display: flex;
  background-color: rgba(255, 255, 255, 0.3);
  width: 48%;
  margin: 1%;
  height: 165px;
  /* border: 2px solid white; */
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  border-radius: 10px;
}

.card p {
  position: relative;
  font-size: 33px;
  padding-bottom: 10px;
  /* padding-top: 10px; */
  color: #ffffff;
  font-family: AzoSans;
  margin: 0;
  text-align: center;
}

.sub-menu {
  overflow: hidden !important;
  overflow-x: auto !important;
}
ol {
  position: relative;
  display: block;
  margin: 180px 0;
  height: 4px;
  background: #0000ff;
}
ol::before,
ol::after {
  content: "";
  position: absolute;
  top: -8px;
  display: block;
  width: 0;
  height: 0;
  border-radius: 10px;
  border: 10px solid #0000ff;
}
ol::before {
  left: -5px;
}
ol::after {
  right: -10px;
  border: 10px solid transparent;
  border-right: 0;
  border-left: 20px solid #0000ff;
  border-radius: 3px;
}

/* ---- Timeline elements ---- */

.popup li {
  position: relative;
  top: -118px;
  display: inline-block;
  float: left;
  width: 312px;
  transform: rotate(-21deg);
  font-size: 31px;
  -webkit-animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}
@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.popup li:nth-child(1) {
  animation-delay: 300ms;
}

.popup li:nth-child(2) {
  animation-delay: 600ms;
}

.popup li:nth-child(3) {
  animation-delay: 900ms;
}
.popup li:nth-child(4) {
  animation-delay: 1200ms;
}
.popup li::before {
  content: "";
  position: absolute;
  top: 52px;
  left: -26px;
  display: block;
  width: 9px;
  height: 9px;
  border: 4px solid #000000;
  border-radius: 10px;
  background: #eee;
  animation: pulse-black 2s infinite;
}
@keyframes pulse-black {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

/* ---- Details ---- */

.details {
  display: none;
  position: absolute;
  left: -85px;
  top: 145px;
  padding: 15px;
  border-radius: 3px;
  border-right: 2px solid rgba(0, 0, 0, 0.1);
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  transform: rotate(21deg);
  font-size: 25px;
  background: #fff;
}
.details::before {
  content: "";
  position: absolute;
  left: 10px;
  top: -9px;
  display: block;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-bottom-color: #fff;
  border-top: 0;
}

/* ---- Hover effects ---- */

li:hover {
  cursor: pointer;
  color: #28e;
}
li:hover::before {
  top: 52px;
  left: -31px;
  width: 8px;
  height: 8px;
  border-width: 5px;
  border-color: #28e;
}
li:hover .details {
  display: block;
  color: #444;
}
</style>
